module.exports = __webpack_public_path__ + "static/media/Gambling.d2682122.svg";